import React from "react";
import styled from "styled-components";
import { Curve, RightArrow } from "../svgs";
import { Button, CurveHolder, StyledText } from "./basic";

const FeatureHeader = ({
  image,
  title,
  description,
  buttonText,
  onClick = () => {},
  content,
  background,
  secondaryBackground,
  children,
}) => {
  return (
    <>
      <Header>
        <Image src={image} />
        <Gradient>
          <GradientBody>
            <HeaderContent>
              {title &&
                Array.isArray(title) &&
                title.map((part, index) => {
                  return (
                    <StyledText
                      key={index}
                      style={{
                        fontFamily: "MTNMedium",
                        margin: index !== title.length - 1 ? 0 : "0 0 10px 0",
                      }}
                      size={30}
                      color={"white"}
                    >
                      {part}
                    </StyledText>
                  );
                })}
              {description && (
                <StyledText
                  size={12}
                  color={"white"}
                  style={{
                    textAlign: "left",
                    fontFamily: "MTNRegular",
                    lineHeight: "15.6px",
                  }}
                >
                  {description}
                </StyledText>
              )}
              {!content && buttonText && (
                <Button
                  style={{
                    width: "50%",
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  color={"white"}
                  onClick={onClick}
                >
                  <StyledText style={{ marginRight: 10 }}>
                    {buttonText}
                  </StyledText>
                  <RightArrow />
                </Button>
              )}
              {content}
            </HeaderContent>
          </GradientBody>
        </Gradient>
      </Header>
    </>
  );
};

const Header = styled.div`
  height: 300px;
  overflow: hidden;
  position: relative;
  // border-radius: 20px;
  // margin-top: 15%;
  // margin-inline: 20px;
`;

const Gradient = styled.div`
  width: 100%;
  height: 300px;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.17) 39.58%,
    #000000 100%
  );
  position: absolute;
  z-index: 1;
  display: grid;
  grid-auto-flow: column;
  align-items: flex-start;
  padding: 5px;
`;

const Image = styled.img`
  width: 100%;
  height: 400px;
  margin: 0 0 0 0px;
  position: absolute;
  object-fit: cover;
`;

const GradientBody = styled.div`
  padding: 5px;
  display: flex;
  flex-direction: column;
  height: 80%;
  justify-content: flex-end;
`;

const Tag = styled.div`
  background-color: ${(prop) => prop.color};
  width: min-content;
  padding: 1px;
  margin-block-start: 0;
  margin-block-end: 0;
`;

const HeaderContent = styled.div``;

export default FeatureHeader;
